import Social from "components/common/Social";
import Link from "next/link";
import { footerData } from "store/allData";
import { LogoSVG } from "assets/svg";
import { logoFont } from "assets/font";

const footerLinks = [
  { ref: "/#benefits", text: "Services" },
  { ref: "/#projects", text: "Our work" },
  { ref: "/#team", text: "Team" },
  { ref: "/#contact-us", text: "Contact" },
];

const Footer: React.FC = () => {
  return (
    <footer className="w-full border-t border-white/10 mt-10">
      <div className="max-w-screen-2xl mx-auto px-5 sm:px-8 lg:px-12 py-12 flex flex-col gap-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="flex flex-col items-start gap-3 max-w-xs">
            <span className="flex items-center gap-1">
              <LogoSVG width="2.25rem" />
              <span
                className={`text-lg text-white font-bold ${logoFont.className}`}
              >
                Spila
              </span>
            </span>
            <p className="text-sm text-zinc-500 leading-relaxed">
              A digital product studio building AI, software, and blockchain
              products.
            </p>
          </div>

          <nav aria-label="Footer">
            <ul className="flex flex-wrap gap-x-8 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.ref}>
                  <Link
                    href={link.ref}
                    className="text-sm text-zinc-400 hover:text-white duration-300"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <ul className="flex items-center gap-2.5">
            {footerData.map((social) => (
              <Social
                key={social.href}
                data={social}
                width="38px"
                svgWidth="18px"
                hasTransition={true}
              />
            ))}
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/5 pt-6">
          <p className="text-xs text-zinc-600">
            &copy; {new Date().getFullYear()} Spila. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">
            Built with care — and shipped fast.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
